import { useEffect, useState } from "react";
import axios from "axios";
const apiBase = process.env.REACT_APP_API_URL;
const emojiOptions = ["🔥", "🤩", "😱"];

export default function MatchReactions({ matchId, reactions = {}, selectedEmoji: initialSelectedEmoji = null, accessToken }) {
  const [selectedEmoji, setSelectedEmoji] = useState(initialSelectedEmoji);
  const [localReactions, setLocalReactions] = useState(reactions);

  // Update local state when props change
  useEffect(() => {
    setLocalReactions(reactions);
  }, [reactions]);

  useEffect(() => {
    setSelectedEmoji(initialSelectedEmoji);
  }, [initialSelectedEmoji]);

  const handleReact = async (emoji) => {
    if (!accessToken || selectedEmoji) return;

    try {
      await axios.post(
        `${apiBase}/api/reactions/submit`,
        { match_id: matchId, reaction: emoji },
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );

      setSelectedEmoji(emoji);
      setLocalReactions((prev) => ({
        ...prev,
        [emoji]: (prev[emoji] || 0) + 1,
      }));
    } catch (err) {
      console.error("Reaction submit failed:", err.message);
    }
  };

  return (
    <div className="reaction-bar">
      {emojiOptions.map((emoji) => (
        <button
          key={emoji}
          onClick={() => handleReact(emoji)}
          className="reaction-btn"
          disabled={!!selectedEmoji}
          style={{
            opacity: selectedEmoji && selectedEmoji !== emoji ? 0.5 : 1,
            border: selectedEmoji === emoji ? "1px solid white" : "1px solid gray",
          }}
        >
          {emoji} {localReactions[emoji] || 0}
        </button>
      ))}
    </div>
  );
}
